document.addEventListener( 'DOMContentLoaded', () => {
	// Get all the necessary inputs
	const menuToggle = document.getElementById('mobile-menu-toggle')
	const mobileMenu = document.getElementById('mobile-menu')
	const btnSearch = document.getElementById('search-button');
	const btnSearchText = document.getElementById('search-button-text');
	const inputSearch = document.getElementById('search-input');
	const searchCloseIcon = document.getElementById('search-close-icon');
	const searchResultsContainer = document.getElementById('search-results');
	const spinner = document.getElementById('spinner')
	const notification = document.getElementById('notification');
	const notificationMessage = document.getElementById('notification-message');
	const mobileOpenIcon = document.getElementById('open-icon');
	const mobileCloseIcon = document.getElementById('close-icon');

	// Mobile menu toggle to show/hide mobile menu with Hamburger and Close Icon
	menuToggle.addEventListener('click', () => {
		// Check if the mobile menu is currently hidden
		if(mobileMenu.classList.contains('hidden')) {
			mobileMenu.classList.remove('hidden')
			setTimeout(() => {
				mobileMenu.classList.remove('-translate-x-full');
				mobileMenu.classList.add('translate-x-0');
			}, 10); // Small delay to allow hidden to be removed first

			// Switch Icons
			mobileOpenIcon.classList.add('hidden');
			mobileCloseIcon.classList.remove('hidden');
		} else {
			// Slide out
			mobileMenu.classList.remove('translate-x-0');
			mobileMenu.classList.add('-translate-x-full');
			setTimeout(() => {
				mobileMenu.classList.add('hidden');
			}, 300); // Duration should match the transition time

			// Switch icons back
			mobileOpenIcon.classList.remove('hidden');
			mobileCloseIcon.classList.add('hidden');
		}
	})
	if(btnSearch) {
		btnSearch.addEventListener('click', () => {
			const searchValue = inputSearch.value.trim()
			if(searchValue.length < 4) {
				showNotification('Please enter at least 4 characters to search');
			} else {
				// Start spinner - search - Stop Spinner
				startSearch();
				searchKnowledgeBase(searchValue);
				endSearch();
			}
		});
	}

	if(inputSearch) {
		inputSearch.addEventListener('keydown', event => {
			if (event.key === 'Enter') {
				// Prevent the default form submission, useful if the input was inside a form
				event.preventDefault();
				const searchValue = inputSearch.value.trim()
				if(searchValue.length < 4) {
					showNotification('Please enter at least 4 characters to search');
				} else {
					// Start spinner - search - Stop Spinner
					startSearch();
					searchKnowledgeBase(searchValue);
					endSearch();
				}
			}
	
			if(event.key == 'Escape') {
				// Clear search input and results when the user clicks Esc button
				clearSearch();
			}
		});

		// Show close icon in input when the input is not empty
		inputSearch.addEventListener('input', () => {
			if (inputSearch.value.trim() !== '') {
				searchCloseIcon.classList.remove('hidden');
			} else {
				searchCloseIcon.classList.add('hidden');
			}
		});
	}

	if(searchCloseIcon) {
		// Clear search input and results when close icon is clicked
		searchCloseIcon.addEventListener('click', () => {
			clearSearch();
		});
	}

	function showNotification(message, type='error') {
		notificationMessage.textContent = message

		// Style for different types of notification
		if(type === 'error') {
			notification.classList.remove('bg-green-500');
			notification.classList.add('bg-red-500');
		} else {
			notification.classList.add('bg-green-500');
			notification.classList.remove('bg-red-500');
		}

		// Show notification using Tailwindcss classes
		notification.classList.remove('hidden');
		notification.classList.add('animate-bounce');

		// Hide notification after 3 seconds
		setTimeout(() => {
			notification.classList.add('hidden')
		}, 3000);
	}

	// Function to start searching
	function startSearch() {
		btnSearchText.textContent = 'Searching...';
		spinner.classList.remove('hidden');
		btnSearch.disabled = true;
	}

	// Function to end searching
	function endSearch() {
		btnSearchText.textContent = 'Search';
		spinner.classList.add('hidden');
		btnSearch.disabled = false
	}

	function clearSearch() {
		inputSearch.value = '';
		searchResultsContainer.innerHTML = '';
		searchCloseIcon.classList.add('hidden')
	}
});

// fetch is an async function
// fetch the search results from WordPress REST Api
async function searchKnowledgeBase( query ) {
	const apiURL = `${ siteSettings.root_rest_api_url }wp/v2/posts?search=${ query }`;
	const response = await fetch( apiURL, {
		headers: {
			// Include the nonce for security
			'X-WP-Nonce': siteSettings.nonce,
		},
	});
	const results = await response.json();
	displaySearchResults( results );
}

// Display Search Results in results container
function displaySearchResults( results ) {
	const searchResultsContainer = document.getElementById('search-results');
	// Clear previous search results
	searchResultsContainer.innerHTML = '';
	if (results.length) {
		// If there are search results, then generate html with the search results
		results.forEach( ( result ) => {
			const resultItem = document.createElement( 'div' );
			resultItem.classList.add('result-item');
			resultItem.innerHTML = `
                <h2 class="font-semibold text-lg">
					<a class="hover:text-yellow-500" href="${ result.link }">${ result.title.rendered }</a>
				</h2>
                <p>${ result.excerpt.rendered }</p>
            `;
			searchResultsContainer.appendChild( resultItem );
		} );
	} else {
		searchResultsContainer.innerHTML = '<p>No articles found.</p>';
	}
}